export const validation = {
  headingMaxChar: 50,
  subTitleMaxChar: 50,
  paragraphMaxChar: 100,
  title: { required: true }
}
